import {useEffect, useSyncExternalStore} from "react";
import {useSearchParams} from "react-router-dom";
import {clearOrderHash, getOrderHash, storeOrderHash, subscribeToOrderHash} from "../utils/cookies";

const ORDER_HASH_SEARCH_PARAM_KEY = "orderHash";

export function usePublicOrderHash() {
    const [searchParams] = useSearchParams();

    const cookieOrderHash = useSyncExternalStore(subscribeToOrderHash, getOrderHash, () => null);

    const urlOrderHash = searchParams.get(ORDER_HASH_SEARCH_PARAM_KEY);
    const isInitialized = !!cookieOrderHash || !urlOrderHash;

    // Uses replaceState instead of setSearchParams to preserve the URL hash
    // (Cookiebot consent via #cc=...). setSearchParams would drop it.
    const clearHashFromUrl = () => {
        const newParams = new URLSearchParams(window.location.search);
        newParams.delete(ORDER_HASH_SEARCH_PARAM_KEY);
        const newUrl = newParams.toString()
            ? `${window.location.pathname}?${newParams.toString()}${window.location.hash}`
            : `${window.location.pathname}${window.location.hash}`;
        window.history.replaceState(window.history.state, "", newUrl);
    };

    useEffect(() => {
        if (!urlOrderHash) return;
        if (urlOrderHash === cookieOrderHash) return;

        storeOrderHash(urlOrderHash);
        clearHashFromUrl();
    }, [urlOrderHash, cookieOrderHash]);

    return {
        orderHash: cookieOrderHash,
        isInitialized,
        clearOrderHash: clearOrderHash,
    };
}
